import { ColumnCardCarousel } from '@/components/ui/data-display/cards/ColumnCardCarousel';

export const RoundCarouselItem = ({ data }) => {
  const imagePrefix = '';
  return (
    <ColumnCardCarousel
      id={data?.meta?.id}
      data={{
        img_round_carousel: data?.fields?.img_round_carousel
          ? imagePrefix + data?.fields?.img_round_carousel
          : undefined,
        title: data?.fields?.title,
        alt_img: data?.fields?.alt_img,
        cta_text: data?.fields?.title,
        cta_slug: data?.fields?.url,
      }}
    />
  );
};
